import {makeParam} from './make-param'

export function makeCanonicalUrl(host: string, zoneName?: string, tariff?: string): string {
  return `${/(http(s?)):\/\//i.test(host) ? '' : 'https://'}${host}/order/${makeParam(zoneName) + makeParam(tariff)}`
}
